export enum LayoutEvent {
  Shown = 'layout-shown',
  Scrolled = 'layout-scrolled',
  ViewAllClicked = 'layout-view-all-clicked',
}

export enum GameEvent {
  CategorySelected = 'game-category-clicked',
  CardClicked = 'game-card-clicked',
}
